import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=bff1f090&scoped=true&"
import script from "./CustomerOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerOrders.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrders.vue?vue&type=style&index=0&id=bff1f090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff1f090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
